import {NAME} from './constants';

export const isNavbarCollapsed = state => state[NAME].collapsed;
export const isNavbarTransitioning = state => state[NAME].transitioning;
export const isSelectStoreOpen = state => state[NAME].selectStoreOpen;
export const isChangePasswordOpen = state => state[NAME].changePasswordOpen;
export const isErrorOpen = state => state[NAME].errorOpen;


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/selectors.js
 **/